import PartnerPlatformLandingPageButton from '@root/joinroot.com/src/components/forms/partner-platform-landing-page-form';

export default class InterfaceActionsMap {
  constructor() {
    this.ids = InterfaceActionsMap.IDS;
    this.idToComponentMap = InterfaceActionsMap.ID_TO_COMPONENT_MAP;
  }

  static IDS = {
    OPEN_PARTNER_PLATFORM_LANDING_PAGE_MODAL: 'openPartnerPlatformLandingPageModal',
  };

  static ID_TO_COMPONENT_MAP = {
    [InterfaceActionsMap.IDS.OPEN_PARTNER_PLATFORM_LANDING_PAGE_MODAL]: PartnerPlatformLandingPageButton,
  };
}
